<template>
  <section class="table-classification">
    <div class="table-classification__row-header">
      <div class="table-classification__row-header__col">Torneos</div>
      <div class="table-classification__row-header__col">
        <div class="table-classification__row-header__col__text">- 45’</div>
        <div class="table-classification__row-header__col__text-leyend">(minutos)</div>
      </div>
      <div class="table-classification__row-header__col">
        <div class="table-classification__row-header__col__text">45’ a 50’</div>
        <div class="table-classification__row-header__col__text-leyend">(minutos)</div>
      </div>
      <div class="table-classification__row-header__col">
        <div class="table-classification__row-header__col__text">50’ a 54’</div>
        <div class="table-classification__row-header__col__text-leyend">(minutos)</div>
      </div>
      <div class="table-classification__row-header__col">
        <div class="table-classification__row-header__col__text">54’ +</div>
        <div class="table-classification__row-header__col__text-leyend">(minutos)</div>
      </div>
    </div>

    <template v-for="(dataItem, indexPage) in data">
      <div :key="indexPage" class="table-classification__row " :class="{ 'row-margin': indexPage == 0 }">
        <div
          class="table-classification__row__col "
          :class="{ 'border-top-left-right': indexPage == 0, 'border-bottom-left-right': indexPage == data.length - 1 }"
        >
          <div class="text-pc">{{ dataItem.season }}</div>
          <div class="text-movil">{{ dataItem.seasonShort }}</div>
        </div>
        <div
          class="table-classification__row__col color-gray "
          :class="{ 'border-top-left': indexPage == 0, 'border-bottom-left': indexPage == data.length - 1 }"
        >
          {{ dataItem.lap1 }}
        </div>
        <div class="table-classification__row__col color-gray">{{ dataItem.lap2 }}</div>
        <div class="table-classification__row__col color-gray">{{ dataItem.lap3 }}</div>
        <div
          class="table-classification__row__col color-gray "
          :class="{ 'border-top-right': indexPage == 0, 'border-bottom-right': indexPage == data.length - 1 }"
        >
          {{ dataItem.lap4 }}
        </div>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'TableClassification',
  components: {},
  props: {
    /**
     * Seasons objects to fetch games
     * {Array<{id: number, type: number}>} seasons
     */
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.border-top-right {
  border-top-right-radius: 4px;
}
.border-bottom-right {
  border-bottom-right-radius: 4px;
}
.border-top-left {
  border-top-left-radius: 4px;
}
.border-bottom-left {
  border-bottom-left-radius: 4px;
}
.border-top-left-right {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.border-bottom-left-right {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.text-pc {
  @media screen and (max-width: 500px) {
    display: none;
  }
}
.text-movil {
  display: none;
  text-transform: uppercase;
  @media screen and (max-width: 500px) {
    display: inline-block;
  }
}
.row-margin {
  margin-top: 2px;
}
.color-gray {
  background: #f8fafc !important;
}
.color-white {
  background: #ffffff !important;
}
.table-classification {
  width: 96.8%;
  margin-left: 1.6%;
  margin-top: 7px;
  height: 210px;
  &__row-header {
    width: 100%;
    height: 52px;
    display: inline-flex;
    &__col:first-child {
      width: 27.24%;
      height: 52px;
      border-radius: 4px;
      background-color: #132739;
      font-size: 13px;
      border-right: solid 1px #132739;
      border-left: solid 1px #132739;
      font-weight: normal;
      font-stretch: normal;
      margin-right: 0.66%;
      margin-left: 0px !important;
      font-style: normal;
      line-height: 52px;
      letter-spacing: -0.26px;
      text-align: center;
      font-family: 'Avenir-Demi';
      color: #fff;
    }
    &__col {
      width: 18.07%;
      height: 52px;
      background-color: #52a0fc;
      border-right: solid 1px #ffffff;
      border-left: solid 1px #ffffff;
      &__text {
        width: 100%;
        height: 15px;
        font-family: 'Avenir-Demi';
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.07;
        letter-spacing: -0.28px;
        text-align: center;
        color: #fff;
        margin-top: 8px;
        @media screen and (max-width: 500px) {
          font-size: 13px;
          margin-top: 10px;
        }
        @media screen and (max-width: 380px) {
          font-size: 12px;
          margin-top: 12px;
        }
        @media screen and (max-width: 340px) {
          font-size: 11px;
          margin-top: 14px;
        }
      }
      &__text-leyend {
        width: 100%;
        font-family: 'Avenir-Regular';
        height: 15px;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.15;
        margin-top: 6px;
        letter-spacing: -0.26px;
        text-align: center;
        color: #fff;
        @media screen and (max-width: 500px) {
          font-size: 12px;
          margin-top: 4px;
        }
        @media screen and (max-width: 380px) {
          font-size: 11px;
          margin-top: 2px;
        }
        @media screen and (max-width: 340px) {
          font-size: 10px;
          margin-top: 0px;
        }
      }
    }
    &__col:nth-child(2) {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-left: 1px solid #52a0fc;
    }
    &__col:nth-child(5) {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-right: 1px solid #52a0fc;
    }
  }
  &__row {
    width: 100%;
    height: 40px;
    display: inline-flex;
    &__col:first-child {
      width: 27.24%;
      height: 40px;
      background-color: #132739;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      border: solid 1px #224361 !important;
      margin-right: 0.66%;
      margin-left: 0px !important;
      font-style: normal;
      line-height: 40px;
      letter-spacing: -0.26px;
      text-align: center;
      font-family: 'Avenir-Demi';
      color: #fff;
    }
    &__col {
      width: 18.07%;
      height: 40px;
      border: solid 1px #ecedef;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 40px;
      font-family: 'Avenir-Bold';
      letter-spacing: -0.28px;
      text-align: center;
      color: #132839;
    }
  }
}
</style>
